import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import api, { VendorLogDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";

export interface VendorLogsGridProps {
  vendorId?: string;
  onRowSelected?: (row: VendorLogDto | null) => void;
}

const columns: GridColDef<VendorLogDto>[] = [
  { field: "eventName", headerName: "Event", width: 100, editable: false, sortable: true, filterable: false },
  { field: "log", headerName: "Log", minWidth: 200, flex: 400, editable: false, sortable: false, filterable: false },
  { field: "isError", headerName: "error", width: 60, editable: false, sortable: true, filterable: false, align: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
  { field: "createdAt", headerName: "time", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
];

export const VendorLogsGrid = (props: VendorLogsGridProps) => {
  const { vendorId, onRowSelected } = props;

  const loadData = async (page: number, size: number, sort: string): Promise<PaginationData<VendorLogDto>> => {
    if (vendorId) {
      return await api.vendor.logs({ page, size, sort, vendorId } as any);
    }
    return { data: [], count: 0 } as any;
  };

  return <PaginatedDataGrid loadData={loadData} columns={columns} onRowSelected={onRowSelected} />;
};
